import { render } from "./Oferta.vue?vue&type=template&id=35cc3516&scoped=true&lang=pug"
import script from "./Oferta.vue?vue&type=script&lang=js"
export * from "./Oferta.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-35cc3516"

export default script